/**
 * Edit Scheduling Schema
 *
 * Zod validation schema for editing scheduling records
 */

import { z } from "zod";

/**
 * Schema for editing a single scheduling record
 */
export const editSchedulingArgsSchema = z.object({
  id: z.number().optional(),
  qtyOrdered: z.number().min(1, "O mínimo é 1!"),
  qtyTransported: z.number(),
  order: z.object({ id: z.number() }),
  truck: z.object({
    id: z.string().min(1, "Placa é obrigatória"),
    licensePlate: z.string()
  }),
  driver: z.object({
    id: z.string().min(1, "Motorista é obrigatório"),
    name: z.string()
  }),
  expirationDate: z.string().nonempty("Data de Vencimento é obrigatória"),
  company: z.object({ id: z.number() })
});
